import*as o from"./relative";import*as t from"./absolute";const r={relative:o,absolute:t};export{r as dateTimeFormat};
